<template>
  <div v-if="selectedSurvey">
    <breadcrumb/>
    <show :survey="selectedSurvey"></show>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Breadcrumb from "@/components/General/Breadcrumb";
import Show from "@/components/Surveys/Show";
export default {
  components: {
    Show,
    Breadcrumb
  },
  computed: {
    ...mapState("surveys", ["selectedSurvey"])
  },
  methods: {
    ...mapActions("surveys", ["fetchSurvey"])
  },
  mounted() {
    let surveySlug = this.$route.params.slug;
    this.fetchSurvey(surveySlug);
  },
  updated() {
    if (!this.selectedSurvey) {
      this.$router.push({ name: "surveys" });
    }
  },
};
</script>
